import API_URLS from "constants/apis.url";

import { deleteRequest, getRequest, postRequest, putRequest } from "./api";

const userSettingsURL = "/user/settings";
const isAdminAPI = true;

export const getSettings = () => getRequest(userSettingsURL, false);

export const deleteMFA = async () => await deleteRequest(`/user/profile/mfa`, {}, true);

export const updateSettings = async payload => await putRequest(userSettingsURL, payload, true);

export const getAllReceivers = async () => await getRequest(API_URLS.notificationsReceiversURL, false);

export const updateAlerts = async alarmDetails => {
  const { AlarmID, ...payload } = alarmDetails;
  return await putRequest(API_URLS.notificationsReceiversURL, payload, true);
};
export const addReceiver = async recieverDetail => await postRequest(API_URLS.notificationsReceiversURL, recieverDetail, isAdminAPI);

export const deleteReceivers = async receiversToDelete => await deleteRequest(API_URLS.notificationsReceiversURL, receiversToDelete, isAdminAPI);
